export const settingConstants = {
    CONFIG_REQUEST: "CONFIG_REQUEST",
    CONFIG_SUCCESS: "CONFIG_SUCCESS",
    CONFIG_FAILURE: "CONFIG_FAILURE",
    VALIDATION_ERROR: "VALIDATION_ERROR"
};
